import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Select as MatSelect } from 'react-materialize';

const Content = styled.div`
    display: flex;
    margin: ${props => props.margin ? props.margin : '0 0'};
    // react-materialize always wraps Select in a div.input-field, even with
    // noLayout, carrying materialize's own 1rem top/bottom margin and no
    // width - reset both so spacing is only driven by the margin prop above
    // and the select fills the row like the other form fields.
    .input-field {
        width: 100%;
        margin: 0;
    }
`;

const Select = (props) => {
    return (
        <Content margin={props.margin}>
            <MatSelect
                id={props.id}
                name={props.name}
                multiple={props.multiple}
                noLayout
                value={props.value}
                onChange={props.onChange}
                options={props.options}>
                {props.children}
            </MatSelect>
        </Content>
    );
}

Select.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    multiple: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    margin: PropTypes.string,
    options: PropTypes.object,
    onChange: PropTypes.func,
    children: PropTypes.any
}

export default Select;
